import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import GiphyItem from './GiphyItem.react';
import Scrollbars from './../misc/Scrollbars.react.js';
import LazyLoad from 'react-lazyload';
import get from 'lodash/get';

class GiphyContainer extends React.Component {
  constructor(props) {
    super(props);

    this._onWheel = this._onWheel.bind(this);
    this.getGifItems = this.getGifItems.bind(this);
    this.handleGifPress = this.handleGifPress.bind(this);

    this.state = {
      itemContainerWidth: 0,
      gifItems: [],
      onlyStill: true,
    };
  }

	handleGifPress = (sendGif) => {
	  this.props.onGifPress(sendGif);
	};

	handleScroll = (e) => {
	  e.preventDefault();
	};

	_onWheel(e) {
	  const currentScrollDelta = this.refs.scrollbars.getInstance().getScrollLeft();
	  this.refs.scrollbars.getInstance().scrollLeft(currentScrollDelta + e.deltaY);
	}

	componentDidUpdate(prevProps, prevState) {
	  if (prevState.onlyStill !== this.state.onlyStill) {
	    this.setState({ gifItems: this.getGifItems() });
	  }
	  if (prevProps.term !== this.props.term) {
	    this.setState({ gifItems: this.getGifItems() });
	  }
	}

	// eslint-disable-next-line camelcase
	UNSAFE_componentWillReceiveProps(nextProps) {
	  let onlyStill = this.state.onlyStill;
	  if (this.state.onlyStill && nextProps.isOpen) {
	    onlyStill = false;
	  }
	  this.setState({ onlyStill });
	}

	componentDidMount() {
	  this.setState({ gifItems: this.getGifItems() });
	}

	getGifItems() {
	  let itemContainerWidth = 0;
	  const totalGifCount = 0;
	  const gifItems = this.props.gifs.map((image) => {
	    if (image.images.fixed_height_small.url && image.images.original.url) {
	      const placeholder_url = image.images.fixed_height_small_still.url;
	      itemContainerWidth += parseInt(image.images.fixed_height_small_still.width);

	      let url = placeholder_url;
	      if (!this.state.onlyStill) {
	        url = image.images.fixed_height_small.url;
	      }

	      return (
  <GiphyItem
    onGifPress={this.handleGifPress}
    key={url}
    onlyStill={this.state.onlyStill}
    thumbHeight="100px"
    placeholder_url={placeholder_url}
    url={url}
    send_url={image.images.original.url}
  />
	      );
	    }
	  });

	  this.setState({
	    itemContainerWidth,
	  });

	  return gifItems;
	}

	render() {
	  let gifItems;

	  if (!this.props.gifs || this.props.gifs.length == 0) {
	    gifItems = <span className="giphy-empty">{get(translations, 'txt: Nekas netika atrasts', '')}</span>;
	  } else {
	    gifItems = this.state.gifItems;
	  }

	  return (
  <div className="horizontalScroll">
    <div id="giphy-content" style={{ height: '100%' }}>
      <Scrollbars
        ref="scrollbars"
        onWheel={this._onWheel}
        style={{ height: '110px', overflowY: 'hidden' }}
      >
        <div style={{ height: '100px', width: `${this.state.itemContainerWidth}px` }}>
          {gifItems}
        </div>
      </Scrollbars>
    </div>
  </div>
	  );
	}
}

module.exports = GiphyContainer;
